import { OAuth2SessionError } from "../oauth2/OAuth2SessionError";

export class SnackbarService{
    constructor() {
        this.$store = null;
    }

    /**
   * Création d'un plugin vuex pour récupérer le store
   * @returns
   */
    createVuexPlugin() {
        return store => {
            this.$store = store;
        }
    }

    /**
     * Interception des erreurs de session OAuth2
     * @returns
     */
    catchOAuth2SessionError() {
        return this.catch({ message: "Votre session a expiré.", sub: "Veuillez rafraichir la page pour vous reconnecter.", server: false, acceptOauth2: true });
    }

    /**
     * Permet de récupérer une erreur d'une promise et d'envoyer un message dans le store responsable du snackbar
     * @param {*} options
     * @returns
     */
    catch(options = {}) {
        const {
            timeout = 5000, ignored = [], color = "error",
            message = "Erreur d'accès au serveur",
            sub = null,
            server = true,
            acceptOauth2 = false,
        } = options;
        return error => {
            const status = error.response?.status;
            const statusOk = !ignored.includes(status);
            const oauth2Ok = acceptOauth2 || !(error instanceof OAuth2SessionError);
            if (statusOk && oauth2Ok) {
                //transmission du message au store global
                var text = message;
                var subtext = sub;
                if (server) {
                    const data = error?.response?.data;
                    subtext = data || error.message;
                    if( data instanceof Blob && "application/json" === data.type) {
                        subtext = "Merci de contacter le support EPELFI ou de réessayer ultérieurement";
                    }
                }
                this.$store.commit("snackbar/display", { text, subtext, color, timeout });
            }

            //relancement de l'erreur
            throw error;
        };
    }
}
